import { Suspense } from "react";
import lazy from "@/utils/lazyWithReload";
import { Navigate, Outlet } from "react-router";
import { CircleLoading } from "@/components/loading";
import type { AppRouteObject } from "#/router";
import { FilterOutlined } from "@ant-design/icons";

const DataCleaningPage = lazy(() => import("@/pages/datacleaning/UploadCsv"));
const DataAnalysisAgent = lazy(() => import("@/pages/DataAnalysisAgent/index"));
const NewDataAnalysisAgent = lazy(() => import("@/pages/NewDataAnalysisAgent/index"));

const BiStyleAgent = lazy(() => import("@/pages/PowerBIStyleDashboard/index"))
// const CleanWorkflowDashboardAgent = lazy(() => import("@/pages/CleanDashboardFlowAgentVersion3/index"))
const CleanWorkflowDashboardAgent = lazy(() => import("@/pages/SmartDashboardNewWorkFlowWithBasicCleaning/index"))
const NewDataCleaningPage = lazy(() => import("@/pages/NewDataCleaning/index"));
const EnhancedDataCleaningPage = lazy(() => import("@/pages/EnhancedDataCleaning/index"));
const NewDataMergingPage = lazy(() => import("@/pages/NewDataMerging/index"));

const datacleaning: AppRouteObject = {
  order: 4,
  path: "agents",
  element: (
    <Suspense fallback={<CircleLoading />}>
      <Outlet />
    </Suspense>
  ),
  meta: {
    label: "AI Agents",
    icon: <FilterOutlined className="ant-menu-item-icon" style={{ fontSize: 24 }} />,
    key: "/agents",
  },
  children: [
    {
      index: true,
      element: <Navigate to="upload-csv" replace />,
    },
    {
      path: "upload-csv",
      element: <DataCleaningPage />,
      meta: {
        label: "Data Preparation Agent",
        key: "/agents/upload-csv"
      },
    },
    {
      path: "data-analysis-agent",
      element: <DataAnalysisAgent />,
      meta: {
        label: "Data Analysis Agent",
        key: "/agents/data-analysis-agent"
      },
    },
    {
      path: "new-data-analysis-agent",
      element: <NewDataAnalysisAgent />,
      meta: {
        label: "New Data Analysis Agent",
        key: "/agents/new-data-analysis-agent"
      },
    },
    {
      path: "new-data-analysis-agent-powerbi",
      element: <BiStyleAgent />,
      meta: {
        label: "New Data Analysis Agent POWER BI",
        key: "/agents/new-data-analysis-agent-powerbi"
      },
    },
    {
      path: "merge-files",
      element: <NewDataMergingPage />,
      meta: {
        label: "Merge Datasets",
        key: "/agents/merge-files"
      },
    },
    {
      path: "data-merging",
      element: <NewDataMergingPage />,
      meta: {
        label: "Merge Datasets",
        key: "/agents/data-merging"
      },
    },
    {
      path: "smart-dashboard-agent",
      element: <CleanWorkflowDashboardAgent />,
      meta: {
        label: "Smart Dashboard Agent",
        key: "/agents/smart-dashboard-agent"
      },
    },
    {
      path: "data-cleaning",
      element: <EnhancedDataCleaningPage />,
      meta: {
        label: "Data Cleaning",
        key: "/agents/data-cleaning",
      },
    },
    {
      path: "enhanced-data-cleaning",
      element: <Navigate to="/agents/data-cleaning" replace />,
      meta: {
        label: "Data Cleaning",
        key: "/agents/enhanced-data-cleaning",
        hideMenu: true,
      },
    },
    {
      path: "legacy-data-cleaning",
      element: <NewDataCleaningPage />,
      meta: {
        label: "Legacy Data Cleaning",
        key: "/agents/legacy-data-cleaning",
        hideMenu: true,
      },
    },

  ],
};

export default datacleaning;